export default "__VITE_ASSET__zDBKRL0F__"